class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // setUpsell();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    if (typeof window.dispatchViewCart === 'function') {
      fetch('/cart.js').then((res) => res.json()).then((data) => {
        window.dispatchViewCart(data);
      }).catch(function() {});
    }

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.querySelector('#CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    const data = await getCart();
    updateCartLeadTime(data);
    deliveryPromos(data);
    // setUpsell();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    this.disposalPopup();
    window.loyaltylion && window.loyaltylion.ui.refresh();
  }
  async renderContentsSwatch(data,removeDrawers,openDrawer) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.classList.contains('is-empty') &&
    this.classList.remove('is-empty');
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then(async (responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    }).catch((e) => {
      console.error(e);
    });
    updateCartLeadTime(data);
    deliveryPromos(data);
    // setUpsell();
    if(openDrawer == true){

    }else{
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
    document.querySelector('.cart-count-bubble span[aria-hidden="true"]').innerHTML = data.item_count;
    if(removeDrawers){
      const drawer = getElement('[data-module="drawers"]')
      drawer.classList.remove('drw-Drawers-active')
      this.disposalPopup();
    }
    setTimeout(() => {
      window.loyaltylion && window.loyaltylion.ui.refresh();
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  disposalPopup(){
    const disposalPopup = getElements('.cart-item__disposal .js-Cart_mattressDisposalInfo');
    if (disposalPopup) {
      const disposalModal = document.body.querySelector('.js-Product_mattressDisposalModal');
      const disposalModalClose = document.body.querySelector('.js-Product_mattressDisposalModalClose');
      if (disposalModal && disposalModalClose) {
        disposalPopup.forEach(el => {
          el.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'true'));
        });
        disposalModalClose.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'false'));
      }
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

const deliveryPromos = (data) => {
  const messageArray = []
  const lineItemsWithProductsSets = data.items
  const {
    set1Enabled,
    set1Type1,
    set1Type2,
    set1Message1,
    set1Message2,
    set1QualifiesMessage,
    set1Url1,
    set1Url2,
    set2Enabled,
    set2Type1,
    set2Type2,
    set2Message1,
    set2Message2,
    set2QualifiesMessage,
    set2Url1,
    set2Url2,
    set3Enabled,
    set3Type1,
    set3Type2,
    set3Message1,
    set3Message2,
    set3QualifiesMessage,
    set3Url1,
    set3Url2,
  } = window.theme.pushCartSetMessages

  let discountPrice = 0
  const getSetMessage = (
    item,
    type1,
    type2,
    message1,
    message2,
    qualifiesMessage,
    url1,
    url2,
  ) => {
    const productType = item.product_type.toLowerCase()
    const type1Lower = type1.toLowerCase().split(',')
    const type2Lower = type2.toLowerCase().split(',')

    if (!type1Lower.includes(productType) && !type2Lower.includes(productType)) {
      return
    }

    let messageToAdd
    let urlToAdd

    if (
      type1Lower.includes(productType) &&
      !lineItemsWithProductsSets.find(item =>
        type2Lower.includes(item.product_type.toLowerCase()),
      )
    ) {
      messageToAdd = message1
      urlToAdd = url2
    } else if (
      type2Lower.includes(productType) &&
      !lineItemsWithProductsSets.find(item =>
        type1Lower.includes(item.product_type.toLowerCase()),
      )
    ) {
      messageToAdd = message2
      urlToAdd = url1
    } else {
      messageToAdd = qualifiesMessage
    }

    if (!messageArray.find(mess => mess.message === messageToAdd)) {
      messageArray.push({ message: messageToAdd, url: urlToAdd })
    }
  }

  lineItemsWithProductsSets.forEach(item => {
    set1Enabled &&
      getSetMessage(
        item,
        set1Type1,
        set1Type2,
        set1Message1,
        set1Message2,
        set1QualifiesMessage,
        set1Url1,
        set1Url2,
      )
    set2Enabled &&
      getSetMessage(
        item,
        set2Type1,
        set2Type2,
        set2Message1,
        set2Message2,
        set2QualifiesMessage,
        set2Url1,
        set2Url2,
      )
    set3Enabled &&
      getSetMessage(
        item,
        set3Type1,
        set3Type2,
        set3Message1,
        set3Message2,
        set3QualifiesMessage,
        set3Url1,
        set3Url2,
      )
    if(item.line_level_total_discount > 0 && item.discounts[0].title === 'Bed and Mattress Saving') {
      discountPrice += item.line_level_total_discount;
    }
  })
  messageArray.forEach(message => {
    if(message.message === 'Saved £100 on bed and mattress') {
      message.message = `Saved ${Shopify.formatMoney(discountPrice)} on bed and mattress`
    }
  })

  if(messageArray.length > 0){
    let deliveryPromoHtml = ``;
    messageArray.map((deliveryPromo, idx) => {
      const Tag = deliveryPromo.url ? 'a' : 'p'
      deliveryPromoHtml += `<${Tag} class="psh-Body_DeliveryPromo ${deliveryPromo.url ? ' psh-Body_DeliveryPromo-link' : ''}" ${deliveryPromo.url ? `href="${deliveryPromo.url}"` : ''}>
        <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="9.5" r="8.5" stroke="currentColor"/><path d="M11.06 5.491c0-.408-.258-.666-.639-.666-.516 0-.83.517-.83.952 0 .422.286.653.613.653.53 0 .857-.517.857-.939Zm-.72 3.36c0-.83-.408-1.306-1.02-1.306-.789 0-1.374.789-1.945 2.026l.462.204c.436-.843.83-1.536 1.265-1.536.204 0 .259.19.259.38 0 1.088-1.17 2.83-1.184 4.108-.013.761.422 1.17 1.02 1.17.64 0 1.252-.49 1.823-2.163l-.463-.15c-.38.993-.707 1.51-1.047 1.51-.231 0-.313-.177-.313-.354 0-.897 1.143-2.76 1.143-3.89Z" fill="currentColor"/></svg>
        ${deliveryPromo.message}
      </${Tag}>`
    })
    const promoDiv = getElement('.drawer__promos');
    promoDiv.innerHTML = deliveryPromoHtml;
  }
}
